import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-286">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-287">
        <span className="text-lg font-bold text-navy-800 group-hover:text-teal-700 transition-colors" data-id="element-288">
          {question}
        </span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-gray-400" data-id="element-289" /> : <ChevronDown className="h-5 w-5 text-gray-400" data-id="element-290" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-291">
        <p className="text-lg-body text-text-body" data-id="element-292">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: 'Is this medical advice?',
    answer: "No. It's an educational stabilization system that helps you communicate with your provider and troubleshoot safely."
  }, {
    question: 'What if my main issue is dry mouth?',
    answer: "Perfect—there's an entire map and protocol for it, because dry mouth has multiple causes."
  }, {
    question: "What if I have a beard / I'm a side sleeper?",
    answer: "You're exactly who this was built for. Those are common real-world failure points."
  }, {
    question: 'How fast can this help?',
    answer: 'Some improvements happen in the first week (less chaos). The bigger win is building repeatable nights across 30 days.'
  }];
  return <section className="py-12 px-4 bg-cream" data-id="element-293">
      <div className="max-w-3xl mx-auto" data-id="element-294">
        <FadeIn data-id="element-295">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-800 mb-8 text-center" data-id="element-296">
            Frequently Asked Questions
          </h2>
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 px-8" data-id="element-297">
            {faqs.map((faq, i) => <FAQItem key={i} {...faq} data-id="element-298" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}